"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEEK_OPTIONS = exports.WEEK_LABEL_MAP = exports.MAX_TIME_SLOTS = exports.MAX_INFO_REMARK_LENGTH = exports.MAX_BLOCKS = void 0;
exports.createEmptyBlock = createEmptyBlock;
exports.createEmptyList = createEmptyList;
exports.findFirstValidWeekEnd = findFirstValidWeekEnd;
exports.getOccupiedDaysFromOtherBlocks = getOccupiedDaysFromOtherBlocks;
exports.getPrimaryBusinessTime = getPrimaryBusinessTime;
exports.isTimeRangeOverlap = isTimeRangeOverlap;
exports.isValidWeekRange = isValidWeekRange;
exports.isWeekEndOptionDisabled = isWeekEndOptionDisabled;
exports.isWeekRangeConflict = isWeekRangeConflict;
exports.isWeekRangeOverlap = isWeekRangeOverlap;
exports.isWeekStartOptionDisabled = isWeekStartOptionDisabled;
exports.normalizeBlock = normalizeBlock;
exports.parseBusinessTimeList = parseBusinessTimeList;
exports.serializeBusinessTimeList = serializeBusinessTimeList;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var WEEK_OPTIONS = exports.WEEK_OPTIONS = [{
  label: '周一',
  value: 1
}, {
  label: '周二',
  value: 2
}, {
  label: '周三',
  value: 3
}, {
  label: '周四',
  value: 4
}, {
  label: '周五',
  value: 5
}, {
  label: '周六',
  value: 6
}, {
  label: '周日',
  value: 7
}];
var WEEK_LABEL_MAP = exports.WEEK_LABEL_MAP = WEEK_OPTIONS.reduce(function (map, item) {
  map[item.value] = item.label;
  return map;
}, {});
var MAX_BLOCKS = exports.MAX_BLOCKS = 2;
var MAX_TIME_SLOTS = exports.MAX_TIME_SLOTS = 12;
var MAX_INFO_REMARK_LENGTH = exports.MAX_INFO_REMARK_LENGTH = 30;
function createEmptyBlock() {
  return {
    weekStart: 1,
    weekEnd: 1,
    infoRemark: '',
    timeSlots: [{
      timeRange: null
    }]
  };
}
function createEmptyList() {
  return [createEmptyBlock()];
}
function timeToMinutes(timeStr) {
  if (!timeStr) return null;
  var _timeStr$split$map = timeStr.split(':').map(Number),
    _timeStr$split$map2 = _slicedToArray(_timeStr$split$map, 2),
    hour = _timeStr$split$map2[0],
    minute = _timeStr$split$map2[1];
  return hour * 60 + minute;
}
function isTimeRangeOverlap(rangeA, rangeB) {
  if (!rangeA || !rangeB || rangeA.length !== 2 || rangeB.length !== 2) return false;
  var startA = timeToMinutes(rangeA[0]);
  var endA = timeToMinutes(rangeA[1]);
  var startB = timeToMinutes(rangeB[0]);
  var endB = timeToMinutes(rangeB[1]);
  if ([startA, endA, startB, endB].some(function (v) {
    return v === null;
  })) return false;
  return startA <= endB && startB <= endA;
}
function isWeekRangeOverlap(rangeA, rangeB) {
  if (!rangeA || !rangeB) return false;
  var startA = rangeA.weekStart,
    endA = rangeA.weekEnd;
  var startB = rangeB.weekStart,
    endB = rangeB.weekEnd;
  if (!startA || !endA || !startB || !endB) return false;
  return startA <= endB && startB <= endA;
}
function isValidWeekRange(weekStart, weekEnd) {
  return weekStart && weekEnd && weekEnd >= weekStart;
}

/** 获取其他营业时间块已占用的星期（1-7） */
function getOccupiedDaysFromOtherBlocks(blocks, excludeIndex) {
  var occupied = new Set();
  blocks.forEach(function (block, index) {
    if (index === excludeIndex) return;
    if (!isValidWeekRange(block.weekStart, block.weekEnd)) return;
    for (var day = block.weekStart; day <= block.weekEnd; day++) {
      occupied.add(day);
    }
  });
  return occupied;
}

/** 当前星期段是否与其他块冲突 */
function isWeekRangeConflict(weekStart, weekEnd, blocks, excludeIndex) {
  if (!isValidWeekRange(weekStart, weekEnd)) return false;
  var current = {
    weekStart: weekStart,
    weekEnd: weekEnd
  };
  for (var i = 0; i < blocks.length; i++) {
    if (i === excludeIndex) continue;
    var other = blocks[i];
    if (!isValidWeekRange(other.weekStart, other.weekEnd)) continue;
    if (isWeekRangeOverlap(current, other)) return true;
  }
  return false;
}

/** 开始星期是否可选：仅禁用已被其他组占用的星期 */
function isWeekStartOptionDisabled(dayValue, blocks, blockIndex) {
  var occupied = getOccupiedDaysFromOtherBlocks(blocks, blockIndex);
  return occupied.has(dayValue);
}

/** 结束星期是否可选：不能早于开始星期，且整段不能与其他组重叠 */
function isWeekEndOptionDisabled(dayValue, weekStart, blocks, blockIndex) {
  if (!weekStart) return false;
  if (dayValue < weekStart) return true;
  return isWeekRangeConflict(weekStart, dayValue, blocks, blockIndex);
}

/** 为当前块找到第一个可用的结束星期（可与开始星期同一天） */
function findFirstValidWeekEnd(weekStart, blocks, blockIndex) {
  if (!weekStart) return null;
  for (var weekEnd = weekStart; weekEnd <= 7; weekEnd++) {
    if (!isWeekEndOptionDisabled(weekEnd, weekStart, blocks, blockIndex)) {
      return weekEnd;
    }
  }
  return null;
}
function normalizeBlock(block) {
  var timeSlots = Array.isArray(block.timeSlots) && block.timeSlots.length ? block.timeSlots.map(function (slot) {
    if (slot.timeRange && Array.isArray(slot.timeRange)) {
      return {
        timeRange: slot.timeRange.length === 2 ? _toConsumableArray(slot.timeRange) : null
      };
    }
    if (slot.beginTime && slot.endTime) {
      return {
        timeRange: [slot.beginTime, slot.endTime]
      };
    }
    return {
      timeRange: null
    };
  }) : [{
    timeRange: null
  }];
  return {
    weekStart: block.weekStart || 1,
    weekEnd: block.weekEnd || block.weekStart || 1,
    infoRemark: (block.infoRemark || '').slice(0, MAX_INFO_REMARK_LENGTH),
    timeSlots: timeSlots
  };
}

/**
 * 编辑回显：优先读 businessTimeList，兼容旧店铺仅有 beginTime/endTime 的情况
 */
function parseBusinessTimeList() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (Array.isArray(source.businessTimeList) && source.businessTimeList.length) {
    return source.businessTimeList.map(function (item) {
      return normalizeBlock(item);
    });
  }
  if (typeof source.businessTimeList === 'string' && source.businessTimeList) {
    try {
      var parsed = JSON.parse(source.businessTimeList);
      if (Array.isArray(parsed) && parsed.length) {
        return parsed.map(function (item) {
          return normalizeBlock(item);
        });
      }
    } catch (error) {
      // ignore invalid json
    }
  }

  // 旧数据兼容：只有 beginTime/endTime 时，回显为「周一至周日 + 单个时间段」
  if (source.beginTime && source.endTime) {
    return [{
      weekStart: 1,
      weekEnd: 7,
      infoRemark: '',
      timeSlots: [{
        timeRange: [source.beginTime, source.endTime]
      }]
    }];
  }
  return createEmptyList();
}
function serializeBusinessTimeList() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var serialized = list.map(function (block) {
    return {
      weekStart: block.weekStart,
      weekEnd: block.weekEnd,
      infoRemark: block.infoRemark || '',
      timeSlots: (block.timeSlots || []).map(function (slot) {
        return {
          beginTime: slot.beginTime || (slot.timeRange ? slot.timeRange[0] : ''),
          endTime: slot.endTime || (slot.timeRange ? slot.timeRange[1] : '')
        };
      }).filter(function (slot) {
        return slot.beginTime && slot.endTime;
      })
    };
  }).filter(function (block) {
    return block.timeSlots.length && block.weekEnd >= block.weekStart;
  });
  return serialized;
}
function getPrimaryBusinessTime() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var firstBlock = list[0];
  var firstSlot = firstBlock && firstBlock.timeSlots && firstBlock.timeSlots[0];
  if (!firstSlot) {
    return {
      beginTime: '',
      endTime: ''
    };
  }
  return {
    beginTime: firstSlot.beginTime || (firstSlot.timeRange ? firstSlot.timeRange[0] : ''),
    endTime: firstSlot.endTime || (firstSlot.timeRange ? firstSlot.timeRange[1] : '')
  };
}